import type React from "react";

import Facebook from "@homeinstead/icons/Facebook";
import Instagram from "@homeinstead/icons/Instagram";
import LinkedIn from "@homeinstead/icons/LinkedIn";
import TikTok from "@homeinstead/icons/TikTok";
import Youtube from "@homeinstead/icons/Youtube";
import Link from "next/link";

type SocialLink = {
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  label: string;
};

type SocialLinkTypes =
  | "facebook"
  | "tiktok"
  | "instagram"
  | "linkedin"
  | "youtube";

const SOCIAL_LINKS: Record<SocialLinkTypes, SocialLink> = {
  facebook: {
    Icon: Facebook,
    label: "Home Instead Facebook",
  },
  instagram: {
    Icon: Instagram,
    label: "Home Instead Instagram",
  },
  linkedin: {
    Icon: LinkedIn,
    label: "Home Instead LinkedIn",
  },
  tiktok: {
    Icon: TikTok,
    label: "Home Instead TikTok",
  },
  youtube: {
    Icon: Youtube,
    label: "Home Instead Youtube",
  },
};

type FooterSocialLinks = {
  [key in SocialLinkTypes]: string | undefined;
};

interface FooterSocialIconsProps {
  /** Social media links */
  links: FooterSocialLinks;
}

/**
 * Renders social media icons with links
 */
function FooterSocialIcons({ links }: FooterSocialIconsProps) {
  return (
    <div className="mb-0 sm:mb-3">
      <ul className="flex gap-2 text-new-beginnings-base">
        {Object.entries(SOCIAL_LINKS).map(([key, { Icon, label }]) => {
          const href = links?.[key as SocialLinkTypes];

          return href ? (
            <li key={key}>
              <Link aria-label={label} href={href}>
                <Icon className="min-w-fit fill-new-beginnings-base hover:fill-new-beginnings-tints-700" />
              </Link>
            </li>
          ) : null;
        })}
      </ul>
    </div>
  );
}

export { FooterSocialIcons };
